import { useQuery, type QueryObserverResult, type RefetchOptions } from "@tanstack/react-query";
import { getBranch } from "../api/api";
import type { ErrorMessage, GetBranchResponse } from "../types/types";

export type UseGetBranchReturn = {
  branchData: GetBranchResponse | undefined;
  loading: boolean;
  refetch: (options?: RefetchOptions) => Promise<QueryObserverResult<GetBranchResponse, ErrorMessage>>;
  error: ErrorMessage | null;
};

export const useGetBranch = (): UseGetBranchReturn => {
  const branchId = Number(location.pathname.split("/").at(-1));

  const { data, isLoading, isFetching, error, refetch } = useQuery<GetBranchResponse, ErrorMessage>({
    queryKey: ["branch"],
    queryFn: () => getBranch({ branchId: branchId }),
    staleTime: 0,
  });

  const loading = isLoading || isFetching;

  return {
    branchData: data,
    loading,
    refetch,
    error,
  };
};
export default useGetBranch;
